import store from "@/store";

const directiveFun = (vue) => {
  if (vue) {
    vue.directive("permission", {
      inserted: function (el, binding) {
        let buttonKey = binding.value;
        // 暂时未设置权限
        // if (!store.state.user.actions.includes(buttonKey)) {
        //   el.remove();
        // }
      },
    });
  }
};

export default directiveFun;
